import React, { useEffect, useState } from "react";
import { Input, Button, Avatar } from "antd";
import { ArrowLeftOutlined, SendOutlined } from "@ant-design/icons";
import { useAuth } from "../../hooks/AuthContext";
import { useSocket } from "../../hooks/SocketContext";
import { toast } from "react-toastify";
import { format, isToday } from "date-fns";
import api from "../../services/api";
import { MdPerson, MdPushPin } from "react-icons/md";
import Status from "../status";
import { useNavigate } from "react-router-dom";

const ChatWindow = ({ chat, onBack }) => {
  const { user } = useAuth();
  const { socket } = useSocket();
  const navigate = useNavigate();
  const [newMessage, setNewMessage] = useState("");
  const [isLoadingChat, setIsLoadingChat] = useState(false);
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    if (!socket.connected) {
      socket.connect();
    }

    socket.on("connect", () => {});

    socket.on("newMessage", (message) => {
      if (chat.id == message.ticket_id) {
        setMessages((prevMessagess) => [message, ...prevMessagess]);
      }
    });

    return () => {
      socket.off("connect");
      socket.off("newMessage");
      socket.off("error");
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (chat) {
      loadChat(chat);
    }
  }, [chat]);

  async function loadChat(chat) {
    setIsLoadingChat(true);
    await api
      .get(`/ticket/${chat.id}`)
      .then((response) => {
        setMessages(response.data.messages);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.warn(
            "Ocorreu um erro, verifique sua conexão e tente novamente"
          );
        }
      });
    setIsLoadingChat(false);
  }

  const sendMessage = () => {
    if (!newMessage) {
      toast.warn("Escreva algo para enviar");
    } else {
      const messageSend = {
        send_type: user.type,
        ticket_id: chat.id,
        content: newMessage,
      };
      socket.emit("sendMessage", messageSend, (response) => {
        if (response.status === "ok") {
          setMessages((prevMessages) => [
            {
              content: newMessage,
              created_at: new Date(),
              send_id: user.id,
            },
            ...prevMessages,
          ]);
          setNewMessage("");
        } else {
          console.error(
            "Erro ao enviar mensagem, servidor rejeitou:",
            response.message
          );
          toast.warn("Falha ao enviar mensagem. Tente novamente.");
        }
      });
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="chat-header">
        <Button type="text" icon={<ArrowLeftOutlined />} onClick={onBack} />

        <Avatar
          style={{ marginRight: 8 }}
          src={chat.attendant?.photo_url || null}
          icon={<MdPerson />}
        />
        <div style={{ flex: 1 }}>
          <p>{chat.attendant?.name || "Aguardando atendente"}</p>
          <p
            style={{
              fontSize: 10,
              color: "#888",
            }}
          >
            {chat.protocol_id}
          </p>
        </div>
        <Status isAttendant={true} isMini={true} status={chat.status} />
      </div>
      {chat.order_id && (
        <div
          className="chat-header"
          style={{
            padding: "6px 16px",
          }}
        >
          <MdPushPin />
          <div
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <p
              style={{
                margin: "0 10px",
              }}
            >
              OS relacionada:
            </p>
            <Button
              type="primary"
              style={{
                borderRadius: 50,
                height: 22,
              }}
              onClick={() => {
                navigate(`/${user.type}/os/${chat.order_id}`);
              }}
            >
              {chat.order_id}
            </Button>
          </div>
        </div>
      )}
      <div
        className="chat-window-body"
        style={{ display: "flex", flexDirection: "column-reverse" }}
      >
        {messages.map((msg, index) => {
          const prevMsg = messages[index + 1] || null;
          const backMsg = index > 0 ? messages[index - 1] : null;

          // 1. Criamos chaves únicas para o minuto (Ex: "2025-12-17 16:30")
          // Isso ignora os segundos na comparação.
          const currentMinuteKey = format(
            new Date(msg.created_at),
            "yyyyMMddHHmm"
          );
          const prevMinuteKey = prevMsg
            ? format(new Date(prevMsg.created_at), "yyyyMMddHHmm")
            : null;
          const backMinuteKey = backMsg
            ? format(new Date(backMsg.created_at), "yyyyMMddHHmm")
            : null;

          // 2. Condição de Agrupamento: Mesmo Remetente E Mesmo Minuto
          const isGrouped =
            prevMsg &&
            String(prevMsg.send_id) === String(msg.send_id) &&
            prevMinuteKey === currentMinuteKey;

          const isGroupedBack =
            backMsg &&
            String(backMsg.send_id) === String(msg.send_id) &&
            backMinuteKey === currentMinuteKey;

          const messageClasses = [
            "message",
            msg.send_id === user.id ? "sent" : "received",
            isGrouped || isGroupedBack ? "grouped" : "first-in-group",
          ].join(" ");

          return (
            <div key={msg.id || index} className={messageClasses}>
              {/* SÓ MOSTRA O CABEÇALHO SE NÃO FOR AGRUPADO */}

              <div
                className={`message-content ${
                  isGrouped || isGroupedBack ? "no-tip" : ""
                }`}
              >
                <p>{msg.content}</p>
              </div>
              {!isGroupedBack && (
                <div
                  className="message-header"
                  style={{
                    display: "flex",
                    justifyContent:
                      msg.send_id === user.id ? "flex-end" : "flex-start",
                    gap: "8px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "0.7rem",
                      margin: "5px 0",
                      color: "#888",
                    }}
                  >
                    {format(
                      new Date(msg.created_at),
                      isToday(new Date(msg.created_at))
                        ? "HH:mm"
                        : "dd/MM/yyyy HH:mm"
                    )}
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="chat-footer">
        <Input
          placeholder="Digite sua mensagem..."
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          onPressEnter={() => {
            sendMessage();
          }}
          suffix={
            <Button
              type="primary"
              icon={<SendOutlined />}
              onClick={() => {
                sendMessage();
              }}
            />
          }
        />
      </div>
    </div>
  );
};

export default ChatWindow;
